import React from 'react';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {DynamicInputField} from 'app-ui-componentlibrary/dist/componentLibrary/form/DynamicInputField';

export {DynamicInputField};
export default connectDynamic(DynamicInputField);
